import { ComponentProps } from 'react';
import Tooltip from 'components/Tooltip';
import EyeOpenImg from 'assets/common/eye-open.svg?react';

type Props = ComponentProps<'svg'> & {
  tooltip: string;
  qaSelector?: string;
};

function RevealIcon({ tooltip, qaSelector, ...rest }: Props) {
  return (
    <Tooltip title={`Reveal ${tooltip}`} placement='bottom' arrow={false}>
      <EyeOpenImg data-qa-selector={qaSelector} {...rest} />
    </Tooltip>
  );
}

export default RevealIcon;
